import React, { useState, useEffect, useRef } from "react";
import clsx from "clsx";

export default function ExtendedProductInclusionsTabs ({ tabs = [], activeTab, onTabClick }) {
  const [visibleTabs, setVisibleTabs] = useState(tabs);
  const [moreTabs, setMoreTabs] = useState([]);
  const [isMoreVisible, setIsMoreVisible] = useState(false);
  const containerRef = useRef(null);
  const moreTabsRef = useRef(null);

  function handleMoreTabClick (tab) {
    onTabClick(tab);
    setIsMoreVisible(false);
  }

  const adjustTabs = () => {
    const container = containerRef.current;
    if (!container || container.offsetParent === null) return;

    let availableWidth = container.clientWidth;
    let usedWidth = 0;
    let moreButtonWidth = moreTabs.length > 0 ? 120 : 0;

    let newVisibleTabs = [];
    let newMoreTabs = [];

    // Measure widths using an off-screen element
    const tempContainer = document.createElement("div");
    tempContainer.style.visibility = "hidden";
    tempContainer.style.position = "absolute";
    tempContainer.style.whiteSpace = "nowrap";
    document.body.appendChild(tempContainer);

    const tabWidths = tabs.map((tab: any) => {
      const el = document.createElement("div");
      el.textContent = tab.label;
      el.style.display = "inline-block";
      el.style.padding = "34px";
      el.style.fontSize = "20px";
      el.style.whiteSpace = "nowrap";
      tempContainer.appendChild(el);
      return el.offsetWidth;
    });

    document.body.removeChild(tempContainer); // Cleanup

    for (let i = 0; i < tabs.length; i++) {
      if (usedWidth + tabWidths[i] + moreButtonWidth > availableWidth) {
        newMoreTabs = tabs.slice(i);
        break;
      }
      usedWidth += tabWidths[i];
      newVisibleTabs.push(tabs[i]);
    }

    setVisibleTabs(newVisibleTabs);
    setMoreTabs(newMoreTabs);
  };

  useEffect(() => {
    const handleResize = () => {
      adjustTabs();
    };

    const observer = new ResizeObserver(() => {
      adjustTabs();
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    window.addEventListener("resize", handleResize);
    adjustTabs();

    return () => {
      window.removeEventListener("resize", handleResize);
      observer.disconnect();
    };
  }, [tabs]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (moreTabsRef.current && !moreTabsRef.current.contains(event.target)) {
        setIsMoreVisible(false);
      }
    };

    if (isMoreVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMoreVisible]);

  return (
    <>
      <ul
        ref={containerRef}
        className='product-inclusions__heading__hamper-types'
      >
        {visibleTabs.map(tab => {
          return (
            <li
              key={tab.value}
              className={clsx('product-inclusions__heading__hamper-types__item', {
                'product-inclusions__heading__hamper-types__item--active': tab.value === activeTab.value
              })}
              onClick={() => onTabClick(tab)}
            >
              {tab.label}
            </li>
          )
        })}

        {moreTabs.length > 0 && (
          <li
            ref={moreTabsRef}
            className={clsx('product-inclusions__heading__hamper-types__item relative')}
            onClick={() => setIsMoreVisible(!isMoreVisible)}
          >
            <div className="flex w-full items-center justify-center">
              <span>More</span>
              <span className="icon-chevron-down"></span>
            </div>

            {isMoreVisible &&
              <ul className="absolute -top-1 -right-1 bg-white border border-black shadow-lg rounded-lg text-left py-1 w-[calc(100%+2rem)] z-10 text-black">
                <li className="flex gap-1 justify-between items-center text-base font-body py-2 px-3 opacity-50">
                  <span>Select one...</span>
                  <span className="icon-chevron-up"></span>
                </li>

                {moreTabs.map(moreTab => {
                  return (
                    <li
                      className={clsx('text-base font-body py-2 px-3 hover:bg-gray-100', {
                        'bg-gray-100': moreTab.value === activeTab.value
                      })}
                      onClick={() => handleMoreTabClick(moreTab)}
                    >
                      {moreTab.label}
                    </li>
                  )
                })}
              </ul>
            }
          </li>
        )}
      </ul>
    </>
  );
};
